import React, { ReactNode } from 'react'

import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'

interface AvatarProps {
  url?: string
  name: string
}

interface CardProps {
  avatar: AvatarProps
  name: string
  description: string
  children: ReactNode
}

const Card = ({ avatar, name, description, children }: CardProps) => {
  return (
    <Box
      border={{
        all: {
          width: 's2',
          style: 'solid',
          color: 'grey400',
        },
      }}
      borderRadius={{
        all: 'abs008',
      }}
      paddingX="s24"
      paddingY="s16"
      aria-label="software-card"
    >
      <Box justifyContent="spaceBetween" alignItems="center" flexDirection="row" gap="s24">
        <Box flexDirection="row" gap="s24" alignItems="center">
          <Avatar size="s48" url={avatar.url} label={avatar.name} />
          <Box gap="s4">
            <Text.Normal weight="medium" color="grey1000" ellipsis>
              {name}
            </Text.Normal>
            <Text.Normal>{description}</Text.Normal>
          </Box>
        </Box>

        <Box alignItems="flexEnd">{children}</Box>
      </Box>
    </Box>
  )
}

export default Card
